export default function(message, type){
	return { message, type }
}